export default __webpack_public_path__ + "static/media/logo-without-tagline.eceff240.svg";